export default __webpack_public_path__ + "static/drivearabia-white-eb40e70e9eed0f528fe82200aba00708.png";